import React, { useMemo, useEffect } from 'react'

import SafeHtml from '@/components/ui/safe-html'
import type { TypeComponentStorylane } from '@/types/ctf'

export type StorylaneProps = TypeComponentStorylane<'WITHOUT_UNRESOLVABLE_LINKS'>['fields']

export default function Storylane({ embedCode }: StorylaneProps) {
  const { script, embedWithoutScript } = useMemo(() => {
    const embedWithoutScript = embedCode.replace(/<script.*?<\/script>/g, '')
    const scriptMatch = embedCode.match(/<script.*?src="(.*?)".*?<\/script>/)
    const script = scriptMatch ? scriptMatch[0] : null
    return { script, embedWithoutScript }
  }, [embedCode])

  // Inject script tag into DOM if not already present
  useEffect(() => {
    if (script) {
      const scriptSrcMatch = script.match(/src="(.*?)"/)
      const scriptSrc = scriptSrcMatch ? scriptSrcMatch[1] : null
      if (scriptSrc && !document.querySelector(`script[src="${scriptSrc}"]`)) {
        const scriptElement = document.createElement('script')
        scriptElement.src = scriptSrc
        scriptElement.async = true
        const dataAttributes = script.match(/data-[\w-]+=".*?"/g)
        if (dataAttributes) {
          dataAttributes.forEach((attr) => {
            const [key, value] = attr.split('=')
            scriptElement.setAttribute(key, value.replace(/"/g, ''))
          })
        }
        document.head.appendChild(scriptElement)
      }
    }
  }, [script])

  return (
    <SafeHtml
      as="div"
      html={embedWithoutScript}
      className="isolate"
      config={{
        ADD_TAGS: ['iframe'],
        ADD_ATTR: [
          'allow',
          'allowfullscreen',
          'frameborder',
          'scrolling',
          'data-storylane-config',
          'onclick',
          'target',
        ],
      }}
    />
  )
}
